import React from "react";

/**
 * LedgerRow — Receipt/invoice-style key-value row used inside the
 * enroll sidebar summary. Tight typography, value right-aligned.
 */
export default function LedgerRow({ label, value }) {
  return (
    <div className="flex items-baseline justify-between gap-3 py-2 md:py-2.5">
      <dt className="text-[10px] md:text-[11px] font-extrabold uppercase tracking-[0.1em] text-slate-400 shrink-0">
        {label}
      </dt>
      <dd className="text-[12px] md:text-[12.5px] font-bold text-velcor-ink text-right truncate min-w-0">
        {value}
      </dd>
    </div>
  );
}
